/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsUpgradeLicense
 */
export interface ControlcenterMelcoModelsUpgradeLicense {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    email_address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    serial_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    version_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    referral_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    step?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    assign_license?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUpgradeLicense
     */
    language?: string | null;
}

export function ControlcenterMelcoModelsUpgradeLicenseFromJSON(json: any): ControlcenterMelcoModelsUpgradeLicense {
    return ControlcenterMelcoModelsUpgradeLicenseFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsUpgradeLicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsUpgradeLicense {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
        'serial_number': !exists(json, 'serial_number') ? undefined : json['serial_number'],
        'version_id': !exists(json, 'version_id') ? undefined : json['version_id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'referral_code': !exists(json, 'referral_code') ? undefined : json['referral_code'],
        'step': !exists(json, 'step') ? undefined : json['step'],
        'assign_license': !exists(json, 'assign_license') ? undefined : json['assign_license'],
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'language': !exists(json, 'language') ? undefined : json['language'],
    };
}

export function ControlcenterMelcoModelsUpgradeLicenseToJSON(value?: ControlcenterMelcoModelsUpgradeLicense | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email_address': value.email_address,
        'serial_number': value.serial_number,
        'version_id': value.version_id,
        'product_code': value.product_code,
        'subscription_code': value.subscription_code,
        'referral_code': value.referral_code,
        'step': value.step,
        'assign_license': value.assign_license,
        'melco_customer_id': value.melco_customer_id,
        'language': value.language,
    };
}


